import React from 'react'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

const useStyles = makeStyles((theme) => ({
  root: {
    '& a': {
      fontWeight: '500',
    },
    '& span~a': {
      marginLeft: '10px',
    },
  },
}))

const TextLink = ({ text, links = [], classNames, dataQsId }) => {
  const classes = useStyles()

  const linksJoined = links
    .map(({ label, target, onClick, replace, dataQsId: linkDataQsId }, index) => {

      // Set the origin to the current window's origin
      // check for http:// or https:// or // in the target URL
      const isExternal = target && /^https?:\/\/|^\/\//.test(target) ? new URL(target).origin !== window.location.origin : false

      const Element = isExternal ? 'a' : Link

      const attributes = onClick
        ? { onClick }
        : {
          ...(isExternal ? { href: target } : { to: target, replace }),
        }

      return <Element key={`link-${index}`} data-qs-id={linkDataQsId} {...attributes}>{label}</Element>
    })
    .reduce((accu, elem) => {
      return accu === null ? [elem] : [...accu, ' | ', elem]
    }, null)

  return (
    <span data-qs-id={dataQsId} className={`${classes.root} ${classNames || ''}`}>
      <span>{text}</span>{linksJoined}
    </span>
  )
}

TextLink.propTypes = {
  text: PropTypes.string,
  links: PropTypes.array,
  classNames: PropTypes.string,
  dataQsId: PropTypes.string,
}

export default TextLink
